var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("wrapper", [
    _c("section", { staticClass: "add-challenge-partner-page" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-md-offset-2" }, [
          _c("div", { staticClass: "box box-info" }, [
            _c("div", { staticClass: "box-header with-border" }, [
              _c("h3", { staticClass: "box-title" }, [_vm._v("Add Partner")])
            ]),
            _c(
              "div",
              { staticClass: "box-body" },
              [
                _c("challenge-partner-form", {
                  attrs: {
                    value: _vm.form,
                    "is-loading": _vm.isSaving,
                    "submit-label": "Create Partner"
                  },
                  on: { validated: _vm.handleSubmit }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }